import { PageTitle } from '@procureai/ui-mui';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '~/common/types';

export const ProcurementKnowledgeTitle = () => {
  const { t } = useTranslation(I18nNamespace.knowledgeRepository);

  const title = t(`ProcurementKnowledge.title`);

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <PageTitle title={title} />
    </>
  );
};
